import { FlexCol } from '@/components/common/Flex';
import { Paragraph } from '@/components/common/Typography';
import BlogLink from '@/components/goals/BlogLink';
import { Center } from '@chakra-ui/react';
import { RetirementGoal } from '@common/goals';
import { getGoalBaseConfig } from '@common/react/goals';
import { getRecommendedRiskScoreUsingTargetDate } from '../helpers';
import { GoalConfig } from './types';

export const RETIREMENT: GoalConfig<RetirementGoal> = {
    inputSteps: [
        // TODO
    ],
    getGoalStatementContent: () => {
        // TODO
        return null;
    },
    getAdditionalConfirmationContent: () => (
        <Center h="full">
            <FlexCol>
                <Paragraph>
                    One place to track and invest in the future you want.
                </Paragraph>
                <Paragraph my={8}>
                    Connect all your 401ks, 403bs, or IRA accounts. Open up a
                    Plenty IRA or Roth IRA account today, to begin investing
                    effortlessly for just 0.20% annually.
                </Paragraph>
                <BlogLink href="https://www.withplenty.com/blog/retirement-planning-three-things-to-consider">
                    See Plenty’s primer on retirement
                </BlogLink>
            </FlexCol>
        </Center>
    ),
    getRecommendedRiskScore: (config) =>
        getRecommendedRiskScoreUsingTargetDate(config),
    getTargetDate: ({ goalData }) => goalData.targetDate,
    ...getGoalBaseConfig('RETIREMENT'),
};
